import { Spacing } from 'UI'

export default theme => ({
  paperClass: {
    width: 'calc(100% / 3)',
    padding: () => Spacing(5),
    background: theme.neutral[400],
    minHeight: 168
  }
})
